import { render, staticRenderFns } from "./SubCategoryList.htm?vue&type=template&id=37511762&scoped=true&"
import script from "./SubCategoryList.ts?vue&type=script&lang=js&"
export * from "./SubCategoryList.ts?vue&type=script&lang=js&"
import style0 from "./SubCategoryList.scss?vue&type=style&index=0&id=37511762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37511762",
  null
  
)

export default component.exports